"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.db_node = void 0;
const common_1 = require("@finley-technologies/common");
const types_1 = require("./types");
const isIntermediateRecord = (_obj) => {
    return true;
};
// create a new UI node of this type.
const createNewNode = () => {
    (0, common_1.finleyAssert)(false, 'db_node can not be created');
};
const isNode = (obj) => {
    return obj.metadata.tapeBuilderNodeType === types_1.nodeType;
};
const getArtifactSlug = (node) => {
    (0, common_1.finleyAssert)(isNode(node), `must be a ${types_1.nodeType} node`);
    return node.configuration.artifactSlug;
};
const getFriendlyName = (node) => {
    // for tape nodes friendly name is artifact slug.
    return getArtifactSlug(node);
};
// typeguard that checks against json schema.
const isConfig = (obj) => {
    throw new Error(`isConfig not implemented for db_node ${obj}`);
};
const getTapeNode = (_node) => {
    throw new Error('getTapeNode not implemented for db_node');
};
/*
 * validate the configuration for the node. This checks shape as well
 * logical correctness.
 * This function should validate the config wrt rest of the graph as well.
 * if there is an error it should return an array of error messages.
 * if there are no errors it should return an empty array.
 */
const hasValidConfig = () => {
    return [];
};
/**
 * Represents a UI node with various properties and methods.
 */
exports.db_node = {
    // what should node say on the tape-buider node creation menu.
    nodeTypeText: 'DB Node',
    // what is the node type. must be one of the constants defined in TapeBuilderNodeType
    nodeType: types_1.nodeType,
    // expose artifactType
    artifactType: types_1.artifactType,
    isOperation: false,
    isRaw: false,
    isFinal: false,
    // operatin nodes dont render badges.
    badgeTexts: ['db_node'],
    getJsonSchema: () => {
        return {};
    },
    createNewNode,
    isNode,
    isIntermediateRecord,
    getFriendlyName,
    isConfig,
    getArtifactSlug,
    getTapeNode,
    // validate the configuration for the node for logical correctness
    hasValidConfig,
    // validate generated config
    validateIntermediateTape: () => [],
};
//# sourceMappingURL=uinode.js.map